export default "__VITE_ASSET__2cbcbd1e__"